import React from "react";
import HelperText from "../FormElements/HelperText";
import "select2";

export default class Selectbox extends React.Component {
  constructor(props) {
    super(props);

    this.selectRef = React.createRef();
  }

  componentDidMount() {
    $(this.selectRef.current).select2({
      minimumResultsForSearch: 6,
    });
    $(this.selectRef.current).on("change.select2", (e) => {
      if (typeof this.props.onChange === "function") {
        this.props.onChange(e);
      }
    });
    $(document).on("select2:open", () => {
      document.querySelector(".select2-search__field").focus();
    });
  }

  render() {
    var options = this.props.options.map((option) => {
      const { value, content } = option;
      return (
        <option key={value} value={value}>
          {content}
        </option>
      );
    });
    return (
      <div className="row">
        <div className="col-sm-12">
          <select
            ref={this.selectRef}
            className="form-control"
            name={this.props.name}
            value={this.props.value}
            onChange={this.props.onChange}
          >
            <option value="" disabled>
              {this.props.placeholder}
            </option>
            {options}
          </select>
          {this.props.helperText && (
            <HelperText>{this.props.helperText}</HelperText>
          )}
        </div>
      </div>
    );
  }
}
